import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  lista: (incluirCanceladas = false, calcularJurosMulta = false) => {
    const params = [];
    if (incluirCanceladas) params.push('incluirCanceladas=true');
    if (calcularJurosMulta) params.push('calcularJurosMulta=true');
    const url = params.length ? `/api/cursos?${params.join('&')}` : '/api/cursos';
    return Vue.http.get(url).then(response => response.data);
  },
  boleto: idLancamento => {
    return Vue.http.get(`/api/cursos/boleto/${idLancamento}`).then(response => response.data);
  },
  cursos: () => {
    return Vue.http.get('/api/cursos/cursos').then(response => response.data);
  },
  turmas: idCurso => {
    return Vue.http.get(`/api/cursos/turmas/${idCurso}`).then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/curso/servico.js